function initSnowflakeAnimations() {
  const wrappers = document.querySelectorAll('.xmas-snowflakes');
  if (!wrappers.length) return;

  if (!('IntersectionObserver' in window)) {
    wrappers.forEach(wrapper => playSnowflakeSequence(wrapper));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      playSnowflakeSequence(entry.target);
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.1
  });

  wrappers.forEach(wrapper => observer.observe(wrapper));
}

function playSnowflakeSequence(wrapper) {
  const rights  = wrapper.querySelectorAll('.snowflake-right');
  const lefts   = wrapper.querySelectorAll('.snowflake-left');
  const bottoms = wrapper.querySelectorAll('.snowflake-bottom');

  const sequence = [
    ...rights,
    ...lefts,
    ...bottoms
  ].filter(Boolean);

  sequence.forEach((el, i) => {
    setTimeout(() => {
      el.classList.add('snow-appear');
    }, i * 1200); 
  });
}

document.addEventListener('DOMContentLoaded', initSnowflakeAnimations);
